import { z } from 'zod';
export const isTLanguage = (str) => str === 'en-us' || str === 'es-mx';
export const I18nStringSchema = z.object({
    'en-us': z.string(),
    'es-mx': z.string()
});
// For content that isn't translated everywhere yet. Consumers fall back to English via t()
export const PartialI18nStringSchema = z.object({
    'en-us': z.string(),
    'es-mx': z.string().optional()
});
export const I18nStringListSchema = z.object({
    'en-us': z.array(z.string()).optional(),
    'es-mx': z.array(z.string()).optional()
});
//# sourceMappingURL=i18n.js.map